var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepTypeTrigger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(90 12 12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3h5v5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 3H3v5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "m15 9 6-6"
}))));
export default SvgStepTypeTrigger;